import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './IncidentType.scss';
import { withTranslation } from 'react-i18next';
import { Button, Form, Modal, OverlayTrigger, Table, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BiDownload, BiPencil, BiSearch, BiSort, BiPlus } from 'react-icons/bi';
import { CgSortAz } from 'react-icons/cg';
import { FcFinePrint } from "react-icons/fc";
import { DEFAULT_ITEMS_PER_PAGE, LIST_DEF_SORT, SORT_ORDER_DESC } from '../../../core/constants/common';
import Utils from '../../../core/utilities/Utils';
import moment from 'moment';
import nodataimg from "../../../images/nodatafound.png";
import Pagination from "../../../components/Pagination/Pagination";
import IncidentTypeService from '../../../core/service/IncidentTypeService';
import { toast } from 'react-toastify';

const IncidentType = ({ t }) => {
  const [key, setKey] = useState("");
  const [mainrtablelist, setMainTableList] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [show, setShow] = useState(false);
  const [editid, setEditId] = useState(null);
  const [incname, setIncName] = useState("");
  const [inccode, setIncCode] = useState("");
  const [incstatus, setIncStatus] = useState(true);
  useEffect(() => {
    getMainTableList(0, itemsPerPage, key);
  }, []);
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    // getCompanies(0, itemsPerPage, key, val);
  };
  const editData = (item) => {
    setEditId(item.id);
    setIncName(item.name);
    setIncCode(item.code);
    setIncStatus(item.status);
    handleShow();
  }
  const handleClose = () => {
    setEditId(null);
    setIncName(null);
    setIncCode(null);
    setIncStatus(true);
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const getMainTableList = (pageNumber, itemsPerPageVal, key) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }

    // var sort = sortField + "," + order;
    IncidentTypeService.getList(pageNumber, perPage, key)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setMainTableList([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };

  const handleSubmit = async (e) => {
    var body = {
      name: incname,
      status: incstatus,
      code: inccode
    }
    if (editid) {
      body['id'] = editid;
    }
    console.log('submit------------', body);
    // return
    IncidentTypeService.onSubmit(editid, body)
      .then((response) => {
        console.log('response', response)
        if (response.status === 200 || response.status === 201) {
          toast.success('Success', {
            position: toast.POSITION.TOP_RIGHT,
          });
          handleClose();
          getMainTableList(0, itemsPerPage, key);
        }
      })
      .catch((error) => {
        console.log('error', error);
        //ErrorHandlingService.handleError(error.response.status);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });

  }
  return (
    <div className="IncidentType">
      <div className="List_header">
        <h5 className="MH">{t("IncidentType.label")}</h5>
        <div className="List_sorts_menu">
          <ul>
            <li>
              <Button variant="secondary" >
                <BiDownload /> {t("Import.label")}
              </Button>
            </li>
            <li>
              <Button variant="primary" onClick={handleShow}>
                <BiPlus />
                {t("New.label")}
              </Button>
            </li>
          </ul>
        </div>
      </div>
      <div className="List_Table_01">
        <div className="List_table-card01_head">
          <div className="List_table-card_Search_01">
            <div className="List_table-card_Search_Box">
              <Form>
                <input
                  type="text"
                  className="form-control"
                  value={key}
                // onChange={handleSearch}
                />
                <Link to="#" className="Search_iocnBox">
                  <BiSearch />
                </Link>
              </Form>
            </div>
          </div>
          <div className="List_table-card01_sort">
            <ul>
              {/* <li>
                  <Link to="#">
                    <BiShareAlt /> Share
                  </Link>
                </li> */}
              <li className="filter">
                <Link to="#">
                  <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                <th className="th_check">
                  <Form.Check
                    inline
                    name="group1"
                    type="checkbox"
                    id="inline-checkbox-1"
                  />
                </th>
                <th>

                  <Link to="#">
                    {t("Name.label")}
                    <BiSort />
                  </Link>

                </th>
                <th>
                  <Link to="#">
                    {t("IncidentType.label")}
                    <BiSort />
                  </Link>{" "}
                </th>
                <th><Link to="#">
                  {t("Status.label")}
                  <BiSort />
                </Link>{" "}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {mainrtablelist.length > 0 ? (
                mainrtablelist?.map((item) => (
                  <tr key={item.id}>
                    <td className="checkbox">
                      {" "}
                      <Form.Check
                        inline
                        name="group1"
                        type="checkbox"
                        id="inline-checkbox-1"
                      />
                    </td>
                    <td>
                      {item.name}
                    </td>
                    <td>{item.code}</td>
                    <td>

                      {item.status
                        ? <Badge bg="badge-Active">{t("Active.label")}</Badge>
                        : <Badge bg="badge-Inactive">{t("Inactive.label")}</Badge>}
                    </td>
                    <td>
                      <div>
                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Edit.label"))}>
                          <BiPencil className='cursor' onClick={() => editData(item)} />
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
              )}


            </tbody>
          </Table>
          <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getMainTableList(pageNum, perPage, key);
              }}
            />
          </div>
        </div>
      </div>
      <Modal show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          < Modal.Title as="h5">Add Incident Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="p-2">
                  <label className="mb-1">{t("Name.label")} <span className='text-red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={incname}
                    required
                    onChange={(e) => setIncName(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Code.label")} <span className='text-red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={inccode}
                    required
                    readOnly={editid != null && editid !== "" && editid !== undefined}
                    onChange={(e) => setIncCode(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Status.label")} <span className='text-red'>*</span></label>
                  <select className="form-select" value={incstatus} onChange={(e) => setIncStatus(e.target.value)}>
                    <option value={true}>{t("Active.label")}</option>
                    <option value={false}>{t("Inactive.label")}</option>
                  </select>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          {(editid != null && editid !== "" && editid !== undefined)
            ? <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
              {t("Update.label")}
            </Button>
            : <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
              {t("Create.label")}
            </Button>}

        </Modal.Footer>
      </Modal>
    </div>
  )
};

export default withTranslation()(IncidentType);
